import { Create, Edit, List, Show, Barcode } from "../Components/index.js";

export default [
    {
        path: "/fd/members",
        component: List,
        name: "fd-members-list",
        meta: {
            requiresAuth: true,
        },
    },
];
